export const validatorPositive = value => {
  if (value >= 0) {
    return true
  }
  return false
}

export const validatorPassword = password => {
  /* eslint-disable no-useless-escape */
  //const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/
  /* eslint-enable no-useless-escape */
  //const validPassword = regExp.test(password)
  //return validPassword

  return password && password.length >= 6
}

export const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum)
  return validCreditCard
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}

export const validatorIpAddress = val => {
  // referência: https://www.codigofonte.com.br/codigos/validar-endereco-ip-com-expressao-regular
  const regx = /^(([1]?[0-9]{1,2}|2([0-4][0-9]|5[0-5])).){3}([1]?[0-9]{1,2}|2([0-4][0-9]|5[0-5]))$/
  return regx.test(val)
}

export function validatorFullName(value) {
  if (!value || typeof value !== 'string') return false

  const trimmed = value.trim().replace(/\s{2,}/g, ' ')

  //Regex: pelo menos dois grupos de letras com espaço(s), pontos, hífens, números, acentos permitidos e &
  //const regex = /^(\S+\s+){1,}\S+$/
  const regex = /^([A-Za-zÀ-ÿ0-9&][A-Za-zÀ-ÿ0-9&'.-]*\s+){1,}[A-Za-zÀ-ÿ0-9&'.-]+$/
  return regex.test(trimmed)
}
